export const APIURL = process.env.REACT_APP_API;
